module.exports = __webpack_public_path__ + "img/Weapon_282.8e3d044e.png";